module.exports = __webpack_public_path__ + "media/bundles/YoupiJob/assets/images/credit-cards/visa-8bd59d79a62534e04eb57eadf5ad3674.jpg";